import React from 'react'

interface SlideOutPanelProps {
  width?: number
  fullScreen?: boolean
  children: React.ReactNode
}

export default function SlideOutPanel({ width = 480, fullScreen = false, children }: SlideOutPanelProps) {
  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    zIndex: 1300,
    display: 'flex',
    justifyContent: fullScreen ? 'stretch' : 'flex-end',
    background: fullScreen ? 'transparent' : 'rgba(37, 46, 61, 0.28)'
  }

  const panelStyle: React.CSSProperties = fullScreen
    ? { width: '100%', height: '100%', background: '#fff', display: 'flex', flexDirection: 'column' }
    : { width, maxWidth: '100%', height: '100%', overflowY: 'auto', background: '#fff' }

  return (
    <div style={overlayStyle}>
      <div style={panelStyle}>{children}</div>
    </div>
  )
}
